import { AbstractControl, FormControl, FormGroupDirective, NgForm, ValidationErrors } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export class CustomValidator {
  static IsNumberValue(control: AbstractControl) {

    let val = control.value;
    if (val === null || val === '') return null;
    const regularExpression = /^[0-9]*(\.[0-9]{0,2})?$/;
    // const regularExpression = /^[0-9]\d{1,2}*$/
    if (!val.toString().match(regularExpression)) {
      return { 'isNumberValueFlag': true }
    }
    return null;
  }

  static password(control: AbstractControl) {
    let val = control.value;
    const regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()^!_#+\-+/])[A-Za-z\d@$!%*?&()^!_#+\-+/]{6,}$/
    if (val === null || val === '')
      return null;
    if (!val.match(regularExpression)) {
      return { 'isPassword': true }
    }
    return false;
  }

  static mobileNumber(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;
    if (!val.toString().match(/^[6-9]\d{9}$/)) return { 'invalidMobileNumber': true };
    return null;
  }
  static lessThanTenDigitMobileNumber(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;
    if (!val.toString().match(/^[0-9]*$/)) return { 'invalidMobileNumber': true };
    return null;
  }

  static NameValidation(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;

    const regularExpression = /^[a-z0-9A-Z-. ]*$/
    if (!val.match(regularExpression)) {
      return { 'IsValidName': true }
    }
    return null
  }
  static NameValidationWithoutNumeric(control: AbstractControl): { IsValidName: boolean } | null {
    const val: string = control.value;

    if (!val) return null;

    return /^[a-zA-Z-. ]*$/.test(val)
      ? null
      : { IsValidName: true };
  }
  // static NameValidationWithoutNumeric(control: AbstractControl) {
  //   let val = control.value;
  //   if (val === null || val === '') return null;

  //   const regularExpression = /^[a-zA-Z-. ]*$/
  //   if (!val.match(regularExpression)) {
  //     return { 'IsValidName': true }
  //   }
  //   return null;
  // }
  static fileNameValidation(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;
    const regularExpression = /^[a-z0-9A-Z-. ]*$/
    if (!regularExpression.test(val)) {
      return { 'IsValidName': true };
    }
    return null;
  }

  static validString(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;

    const regularExpression = /^[a-z0-9A-Z-,./&()\n ]*$/
    if (!val.match(regularExpression)) {
      return { 'isValidString': true }
    }
    return null;
  }

  static addressValidationLine(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;

    const regularExpression = /^[a-z0-9A-Z-.()/,\n ]*$/
    if (!val.match(regularExpression)) {
      return { 'IsValidAddressLine': true }
    }
    return false;
  }

  static email(control: AbstractControl) {
    let val = control.value;
    // const regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()^!_#+\-+/])[A-Za-z\d@$!%*?&()^!_#+\-+/]{6,}$/
    // const regularExpression = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!val.match(regularExpression)) {
      return { 'email': true }
    }
    return null;
  }

  static numericValidator(control: AbstractControl) {
    let val = control.value;
    if (val === null || val === '') return null;
    if (!val.toString().match(/^([0-9]*)$/)) return { 'invalidNumber': true };
    return null;
  }

  static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    if ((control.value as string)?.indexOf(' ') >= 0) {
      return { cannotContainSpace: true }
    }

    return null;
  }

  static passwordMatchValidator(control: AbstractControl) {
    const password: string = control?.get('password')?.value; // get password from our password form control
    const confirmPassword: string = control?.get('confirm_password')?.value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control?.get('confirm_password')?.setErrors({ NoPassswordMatch: true });
    }
  }

}
